import { useEffect, useState } from "react";
import { Inbox, ChevronDown, ChevronUp } from "lucide-react";
import { latestDigest } from "@/lib/scoutApi";

export const DigestPreview = () => {
  const [digest, setDigest] = useState(null);
  const [missing, setMissing] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    latestDigest().then(setDigest).catch(() => setMissing(true));
  }, []);

  if (missing) {
    return (
      <section data-testid="scout-digest-empty" className="border-t border-slate-200 pt-8 text-sm text-slate-500">
        <div className="text-xs tracking-tight text-[var(--accent)] mb-2 flex items-center gap-2">
          <Inbox className="w-3.5 h-3.5" /> Last Digest
        </div>
        No digest emailed yet — the first arrives after the next Tue/Wed 6:30 AM run (or a manual run with the email box ticked).
      </section>
    );
  }
  if (!digest) return null;

  const sent = new Date(digest.sent_at).toLocaleString("en-US", {
    weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
  });

  return (
    <section data-testid="scout-digest" className="border-t border-slate-200 pt-8">
      <div className="text-xs tracking-tight text-[var(--accent)] mb-2 flex items-center gap-2">
        <Inbox className="w-3.5 h-3.5" /> Last Digest
      </div>
      <button
        type="button"
        data-testid="scout-digest-toggle"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between text-left text-sm text-[#0A192F] hover:text-[var(--accent)] transition-colors"
      >
        <span>
          {digest.candidate_count} candidates · {digest.triggered_by} · sent {sent}
        </span>
        {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>
      {open && (
        <iframe
          title="Last ATFQ scout digest"
          data-testid="scout-digest-frame"
          srcDoc={digest.html}
          sandbox=""
          className="mt-4 w-full h-[640px] border border-slate-200 bg-white"
        />
      )}
    </section>
  );
};

export default DigestPreview;
